// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ChevronLeft: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
            <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.05"
                d="M7.795 9.692 4.278 6.175a.246.246 0 0 1 0-.348s0 0 0 0L7.795 2.31"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const ChevronLeftOffset: IconOffset = {
    vertical: 13, // Store Custom Code
    horizontal: 29, // Store Custom Code
};

export default React.memo(ChevronLeft);
